import {
  accountApplicationInReviewUrl,
  acceptPdsUrl,
  emailVerificationUrl,
  identityVerificationUrl,
  onboardingTmdUrl,
  vedaFailUrl,
} from 'src/utils/pageUrls';
import { requireUserLoginInterceptor } from 'scripts/interceptors/authInterceptor';
import { userSelector } from 'scripts/redux/actions/user';
import RegistrationStep from 'scripts/constants/RegistrationStep';
import { getDefaultAuthenticatedPath } from 'scripts/utilities/userAccountHelper';

const registrationStepUrls = {
  [RegistrationStep.VERIFY]: emailVerificationUrl(),
  [RegistrationStep.PDS]: acceptPdsUrl(),
  [RegistrationStep.SETUP]: identityVerificationUrl(),
  [RegistrationStep.VEDA]: vedaFailUrl(),
  [RegistrationStep.TMD]: onboardingTmdUrl(),
  [RegistrationStep.APPLICATION_REVIEW]: accountApplicationInReviewUrl(),
};

export const userWithDetailsCompletedInterceptor = (
  store,
  nextState,
  replaceState,
) => {
  if (requireUserLoginInterceptor(store, nextState, replaceState)) return true;

  const { user } = userSelector(store.getState());

  const redirectUrl = registrationStepUrls[user.nextRegistrationStep];
  const pathname = nextState.location.pathname;

  if (redirectUrl) {
    if (pathname === redirectUrl) return false;
    replaceState(redirectUrl);
    return true;
  }

  if (Object.values(registrationStepUrls).includes(pathname)) {
    replaceState(getDefaultAuthenticatedPath(user));
    return true;
  }

  return false;
};
